import React, { useEffect, useCallback } from 'react';

interface WatchlistAgentPanelProps {
  entityToken: string;
  evaluationToken: string;
  onClose: () => void;
}

export const WatchlistAgentPanel = ({
  entityToken,
  evaluationToken,
  onClose,
}: WatchlistAgentPanelProps) => {
  const onMessage = useCallback(
    ({ data: message, origin }) => {
      if (origin !== window.location.origin) {
        return;
      }

      if (message?.source !== 'embedded-dashboard') {
        return;
      }

      if (message.type === 'close-drawer') {
        onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    window.addEventListener('message', onMessage);

    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, [onMessage]);

  return (
    <iframe
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        display: 'block',
      }}
      src={`${window.origin}/embedded/chat/watchlist-agent/${entityToken}/${evaluationToken}`}
    />
  );
};
